import { Trans } from '@lingui/react/macro';

import styles from './OptionalRequirementsStatement.module.css';

export const OptionalRequirementsStatement = () => {
  return (
    <>
      <h2 className={styles.optionalTitle}>
        <Trans>Some Optional Extras</Trans>
      </h2>
      <p className={styles.optionalSubtitle}>
        <Trans>
          These documents aren’t mandatory, but including them would help us get
          a clearer picture of your business.
        </Trans>
      </p>
    </>
  );
};
